const accessToken = (props) => (
  props.cookies.get('accessToken') != null && new Date() <= new Date(props.cookies.get('accessTokenExpireDate')) ? props.cookies.get('accessToken') : ''
)

export default accessToken;